import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";


export const Paises = () => {
  const cabeceras = [
    "Id", //0
    "Nombre", //1
    "Código",
    "Clave telefónica",
    "Editar",
    "Eliminar",
  ];
  const [parametros] = useState({
    action: "datatable",
    table: "countries",
    rows: "keyCountry,nameCountry,acronim,phoneKey", ///sin espacios y comas
    conditions: "enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "created desc",
  });

  return (
    <div>
      <TableComponent
        titulo="Países"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/paises/crear"
        rutaEditar="/template/paises/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Paises;
